module.exports = __webpack_public_path__ + "img/img_clients11.14f9d092.jpg";